import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import api from '../api'
import InvoiceDoc from '../components/InvoiceDoc'

// Halaman CETAK standalone -- sama pola persis dgn PayrollSlipCetak.jsx (tanpa <Layout/>, dibuka
// window.open() di tab baru dari tombol Cetak di Tagihan.jsx, auto window.print() setelah render).
export default function InvoiceCetak() {
  const { id } = useParams()
  const [tagihan, setTagihan] = useState(null)
  const [error, setError] = useState('')

  useEffect(() => {
    api.get(`/tagihan/${id}`)
      .then(res => setTagihan(res.data))
      .catch(e => setError(e.response?.data?.message || 'Gagal memuat tagihan'))
  }, [id])

  useEffect(() => {
    if (!tagihan) return
    const t = setTimeout(() => window.print(), 400)
    return () => clearTimeout(t)
  }, [tagihan])

  if (error) return <div style={{ padding: 40, fontFamily: 'sans-serif', color: '#b00' }}>{error}</div>
  if (!tagihan) return <div style={{ padding: 40, fontFamily: 'sans-serif' }}>Memuat...</div>

  return (
    <div style={{ maxWidth: 720, margin: '24px auto', padding: '0 20px' }}>
      <InvoiceDoc tagihan={tagihan} />
    </div>
  )
}
